var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._t("activator", null, { triggerUpload: _vm.triggerUpload }),
      _c("input", {
        ref: "upload",
        staticClass: "d-none",
        attrs: { type: "file" },
        on: { input: _vm.handleFileChange },
      }),
      _c(
        "v-dialog",
        {
          attrs: { "hide-overlay": "", persistent: "", width: "300" },
          model: {
            value: _vm.uploadDialog,
            callback: function ($$v) {
              _vm.uploadDialog = $$v
            },
            expression: "uploadDialog",
          },
        },
        [
          _c(
            "v-card",
            { attrs: { color: _vm.error ? "error" : "primary", dark: "" } },
            [
              _c(
                "v-card-text",
                [
                  !_vm.error
                    ? [
                        !_vm.error
                          ? _c("span", [_vm._v("Uploading...")])
                          : _vm._e(),
                        !_vm.error
                          ? _c("v-progress-linear", {
                              staticClass: "mb-0",
                              attrs: { indeterminate: "", color: "white" },
                            })
                          : _vm._e(),
                      ]
                    : [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.error) },
                        }),
                      ],
                ],
                2
              ),
              _vm.error
                ? _c(
                    "v-card-actions",
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", text: "" },
                          on: { click: _vm.closeDialog },
                        },
                        [_vm._v("Close")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }